import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../data/site";
import useSeo from "../hooks/useSeo";

const AboutPage = () => {
  useSeo({
    title: "About · Premium Pitch Wear for the Modern Footballer",
    description:
      "Pritch creates football essentials for players who care about the details — starting from the ground up with premium grip socks.",
    path: "/about",
  });
  return (
    <div data-testid="about-page">
      <section className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
          <p className="overline mb-4">About Pritch</p>
          <h1 className="font-display uppercase text-5xl md:text-7xl tracking-tightest font-bold leading-[0.92]">
            Premium Pitch Wear
            <br />
            for the modern <span className="text-mute">footballer.</span>
          </h1>
          <div className="mt-8 space-y-5 max-w-xl text-mute leading-relaxed">
            <p>
              Pritch was created for players who care about the small details that shape performance
              and style. The fit of the boot. The feel of the sock. The colour of the kit. The
              confidence of a clean matchday look.
            </p>
            <p>
              Starting with premium football grip socks, Pritch is building a new category of pitch
              wear — technical, minimal and designed specifically for football.
            </p>
            <p>
              Every detail of the Pritch Grip Sock — from boot-lock zones to anatomical L/R fit —
              starts from one question: what do footballers actually need on the pitch?
            </p>
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/shop" className="btn-primary">
              Shop grip socks
            </Link>
            <Link to="/team-orders" className="btn-secondary">
              Team orders
            </Link>
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="aspect-[4/5] border border-line overflow-hidden">
            <img src={IMAGES.aboutBrand} alt="Pritch about" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="border-y border-line bg-bone">
        <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-px bg-line border border-line">
          {[
            { k: "01", h: "Grip", b: "Boot-lock zones inside the boot — not generic gym dots." },
            { k: "02", h: "Fit", b: "Thin-touch construction. Anatomical L/R. No bulk." },
            { k: "03", h: "Finish", b: "12 colourways designed to pair with boots and kits." },
            { k: "04", h: "Future", b: "Sock sleeves, base layers, shin pad sleeves, teamwear." },
          ].map((p) => (
            <div key={p.k} className="bg-white p-8">
              <p className="mono text-xs text-mute">{p.k}</p>
              <h3 className="font-display uppercase text-2xl tracking-tightest font-bold mt-3">{p.h}</h3>
              <p className="mt-2 text-sm text-mute">{p.b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
